export const FEATURES = {
  OPS_FOOTER_GOOGLE_REVIEWS: 'ops_footer_google_reviews',
  REL_ACH_BALANCE_REVIEW_V2: 'rel_ach_balance_review_v2',
  REL_PAYMENT_REQUEST_SUCCESS_V2: 'rel_payment_request_success_v2',
  REL_STRIPE_CHARGE_V2: 'rel_stripe_charge_v2',
  REL_TODO_LIST_VISIBILITY: 'rel_todo_list_visibility',
  RELEASE_BUYER_APPLICATION_AUTH_REMOVAL:
    'release_buyer_application_auth_removal',
  REL_UPDATED_LITTER_FLOW: 'rel_updated_litter_flow',
  REL_PAYMENT_REQUEST_MODAL_REDESIGN: 'rel_payment_request_modal_redesign',
  REL_ADULT_DOG_LISTING: 'rel_adult_dog_listing',
  REL_ADULT_DOGS_SEARCH_RESULTS: 'rel_adult_dogs_search_results'
};
